export interface UserInfo {
    name?: string;
    locale?: string;
}


export const UserInfoFromJSON = (json: any) => {
    if((json === null) || (json === undefined)){
        return json;
    }

    return {
        'name': json['name'],
        'locale': json['locale'],
    }
}

export function UserInfoToJSON(value?: UserInfo | null): any {
    if(value === undefined) {
        return undefined;
    }
    if(value === null){
        return null;
    }

    return {
        'name': value.name,
        'locale': value.locale,
    }
}